export const HieQueryDocumentsBlockDocumentationMarkdown = `
# HIE Query Documents

Query the HIE for documents. Once these documents are ready for download, the block will complete. These documents can then be downloaded via the HIE Get Documents block.

## Limitations

### Only one document query at a time per patient
The HIE will only process one document query at a time for a given patient. If a document query is already in flight for that patient, any additional document queries for the **same patient** is silently ignored — the HIE acknowledges the request but does not start new work.

* This applies across flow runs and across agents — two flows that try to use the document query block for the same patient at the same time will collide.
* Different patients are unaffected and run fully in parallel.

## Errors

### \`No patient matches found\`
The upstream block configured as the **Patient Source** returned a response with no patient in it. The HIE only runs when given a real patient to query, so this typically means the upstream lookup (FHIR search, etc.) did not find a matching patient. Verify the Patient Source block is producing the patient you expect, and that its search criteria match a known patient.

### \`Did not receive signal for block within timeout\`
The block waited the full configured timeout without ever receiving a callback from the HIE. The most common cause is the per-patient limitation above: another flow ran an HIE Query Documents block for the same patient at the same time, so this run's callback was never delivered. Other possible causes include the HIE itself being slow or unavailable, or the configured timeout being too short for a large patient record.
`;
